<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I understand that the continuation of electric service depends on my prepaying for service on a timely basis
          and if my balance falls below $0.00, my service may be disconnected with little notice. Some electric
          assistance agencies may not provide assistance to customers that use prepaid services. I understand that while
          I am enrolled in Prepaid Service, I will not receive a monthly bill, but I may request a summary of usage and
          payment.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I wish to establish new service with Payless Power or change from my current retail electric provider (REP) to
          Payless Power. I authorize Payless Power to act as my agent to perform the tasks necessary to switch,
          establish, or change my electric service with Payless Power.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_3" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I have read, understand and accept the Plan Documents and the Terms and Conditions associated with the plan
          selected.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_4" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I understand that enrollment for service can be made only by an applicant or the applicant’s authorized agent,
          and, in accordance with that requirement, I certify that I am at least 18 years of age and legally authorized
          to select or change Retail Electric Providers (REPs) for the address listed above. I authorize Payless Power
          to act as my agent to perform the necessary tasks to establish my electricity service account and, if
          required, switch me from my current REP and instruct my current REP to perform the necessary tasks in order to
          make this change. I understand that I will receive a copy of the terms of service via email, or I can
          contact Payless Power to request the information to be sent in the mail. I understand that if my enrollment
          involves a switch request, I have the right to review and rescind the terms of service, without penalty,
          within three federal business days of receipt, as explained in the terms of service. I have read and
          understand this Authorization and the terms of service that describes the service I will be receiving.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";
import { ref, watch } from "vue";

export default {
  name: "PaylessAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand } = Utilities();
    const authorizations = ref([]);
    watch(authorizations, () => {
      const agreed = authorizations.value.length === 4
      emit('update:modelValue', agreed);
    })
    return {
      authorizations,
      selected_plan,
      plan_brand
    }
  }
}
</script>

<style scoped>

</style>
